/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Sleep_WeekendInputs */

const en_us2_profile_editors_sleep_weekend = /** @type {(inputs: Profile_Editors_Sleep_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On weekends`)
};

const pt_br2_profile_editors_sleep_weekend = /** @type {(inputs: Profile_Editors_Sleep_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fim de semana`)
};

const es_419_profile_editors_sleep_weekend = /** @type {(inputs: Profile_Editors_Sleep_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El fin de semana`)
};

const pt_pt2_profile_editors_sleep_weekend = /** @type {(inputs: Profile_Editors_Sleep_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao fim de semana`)
};

const fr_fr2_profile_editors_sleep_weekend = /** @type {(inputs: Profile_Editors_Sleep_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le week-end`)
};

const de_de2_profile_editors_sleep_weekend = /** @type {(inputs: Profile_Editors_Sleep_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Wochenende`)
};

const it_it2_profile_editors_sleep_weekend = /** @type {(inputs: Profile_Editors_Sleep_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel weekend`)
};

/**
* | output |
* | --- |
* | "On weekends" |
*
* @param {Profile_Editors_Sleep_WeekendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_sleep_weekend = /** @type {((inputs?: Profile_Editors_Sleep_WeekendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Sleep_WeekendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_sleep_weekend(inputs)
	if (locale === "es-419") return es_419_profile_editors_sleep_weekend(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_sleep_weekend(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_sleep_weekend(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_sleep_weekend(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_sleep_weekend(inputs)
	return en_us2_profile_editors_sleep_weekend(inputs)
});
export { profile_editors_sleep_weekend as "profile-editors.sleep_weekend" }